module.exports = __webpack_public_path__ + "static/portal-9e1cee295f7c196f8e36d313f76d98f8.mp4";